"use strict";function t(n,e,u,p,o){if(process.env.NODE_ENV==="production")return null;const r=o||e;return typeof n[e]<"u"?new Error(`The prop \`${r}\` is not supported. Please remove it.`):null}exports.unsupportedProp=t;
